import React, { forwardRef, useContext } from 'react';
import { ChevronIcon } from '@chegg-ui/theme';
import { HeaderContext } from '../../shared';
import { MenuButton } from '../../styles/desktop';
var CenterNavMenuButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var navItemText = _ref.navItemText,
      index = _ref.index,
      isActive = _ref.isActive,
      onClick = _ref.onClick;

  var _useContext = useContext(HeaderContext),
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(MenuButton, {
    ref: ref,
    size: "xsmall",
    screenReaderOnlyText: "".concat(isActive ? 'close' : 'open', " submenu for ").concat(navItemText),
    "data-test": "".concat(dataTestPrefix, "-submenu-button-").concat(index),
    disableHoverAnimation: true,
    onClick: onClick,
    "aria-expanded": isActive ? 'true' : 'false'
  }, /*#__PURE__*/React.createElement(ChevronIcon, {
    pointing: "down",
    iconFill: "fill",
    "data-test": "".concat(dataTestPrefix, "-submenu-button-icon-").concat(index),
    role: "presentation"
  }));
});
CenterNavMenuButton.displayName = 'CenterNavMenuButton';
export default CenterNavMenuButton;